export default __webpack_public_path__ + "static/media/new-user-icon.f39573f4.svg";